
  <!--
 * 竖版
 * @LastEditTime: Sat Sep 14 2024 18:08:17 GMT+0800 (中国标准时间)
 -->
  <template>
  <div id="u_r_0N9I59" :class="[curLang]" class="u_r_0N9I59 route-m"  ><u_c_EPKV20></u_c_EPKV20><u_c_92PM131></u_c_92PM131><u_c_K1XQ135></u_c_K1XQ135><u_c_113F49></u_c_113F49><u_c_2DMU62></u_c_2DMU62><u_c_9LBP81></u_c_9LBP81><u_c_O87P194></u_c_O87P194><div id="u_c_RIM321"  :class="[`normal`,`u_c_RIM321`]" ></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_EPKV20 from "@/components/u_c_EPKV20.vue";import u_c_92PM131 from "@/components/u_c_92PM131.vue";import u_c_K1XQ135 from "@/components/u_c_K1XQ135.vue";import u_c_113F49 from "@/components/u_c_113F49.vue";import u_c_2DMU62 from "@/components/u_c_2DMU62.vue";import u_c_9LBP81 from "@/components/u_c_9LBP81.vue";import u_c_O87P194 from "@/components/u_c_O87P194.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"zh-TW":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['zh-TW']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    const init = inject('init', () => {});

if (window.innerWidth > window.innerHeight && router.hasRoute('index')) {
  let routerCount = router.router.getRoutes().length;
  if (routerCount < 3) {
    init();
  } else {
    router.gotoRouter('/');
  }
} else {
  init();
}

    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>

.zh-TW ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.zh-TW ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.zh-TW ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.default ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.default ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.default ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.u_c_RIM321.normal{
position:relative;
width:100%;
height:1.33rem;
background-color:#272a2c;

}

</style>
